import { Attributes } from "../appUtils";

export const attributes: Attributes = {
  attributes: [
    {
      name: "[identity_social_link_twitter]",
      value: "https://twitter.com/"
    },
    {
      name: "[identity_social_link_facebook]",
      value: "https://www.facebook.com/"
    },
    {
      name: "[identity_social_link_youtube]",
      value: "https://youtube.com"
    },
    {
      name: "[identity_social_link_instagram]",
      value: "https://instagram.com"
    },
    {
      name: "[identity_link_Home]",
      value: "http://test.com/home"
    },
    {
      name: "[identity_link_Products]",
      value: "http://test.com/products"
    },
    {
      name: "[identity_link_Services]",
      value: "http://test.com/services"
    },
    {
      name: "[identity_link_Contact Me]",
      value: "http://test.com/contact-me"
    },
    { name: "[identity_background_color]", value: "#0000ff" },
    { name: "[identity_body_text_color]", value: "#00ff00" },
    { name: "[sender_details_email]", value: "sender_details_email" },
    { name: "[identity_links_color]", value: "#ff0000" },
    { name: "[identity_secondary_font]", value: "Tahoma" },
    { name: "[identity_primary_font]", value: "Times New Roman" },
    { name: "[sender_details_region]", value: "sender_details_region" },
    { name: "[customer_first_name]", value: "customer_first_name" },
    { name: "[customer_email]", value: "customer_email" },
    { name: "[sender_details_country]", value: "sender_details_country" },
    {
      name: "[sender_details_postal_code]",
      value: "sender_details_postal_code"
    },
    { name: "[sender_details_name]", value: "sender_details_name" },
    { name: "[customer_last_name]", value: "customer_last_name" },
    {
      name: "[identity_logo]",
      value:
        "data:image/png;base64,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"
    },
    { name: "[sender_details_city]", value: "sender_details_city" },
    { name: "[identity_buttons_color]", value: "#00ffff" },
    { name: "[sender_details_address]", value: "sender_details_address" },
    { name: "[identity_top_menu_color]", value: "#409d90" }
  ]
};
